import { Typography } from "@mui/material";
import { Modal } from "../components";

export const renderModal = (modalIsOpen, setModalIsOpen, title, content, size = "md") => {
  if (modalIsOpen)
    return (
      <Modal size={size} show={modalIsOpen} setShow={setModalIsOpen} title={() => title}>
        {content}
      </Modal>
    );
};

export const getCurrentDate = () => {
  const today = new Date();

  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");

  const formattedDate = `${day}-${month}-${year}`;

  return formattedDate;
};
